module.exports = __webpack_public_path__ + "img/example.a078b4cd.jpeg";